import React from 'react';
import { PUBLIC_URL } from '../utils/const';
import Layout from '../layouts/Layout';
import { useTranslation } from 'react-i18next';
import { BlogProperties, RouteWrapper, getBlogForLanguage } from 'reactyll';
import { blogs } from '../_blog/routes';
import { ExtraProperties } from '../components/BlogTemplate';
import { sortBlogsByDate } from '../utils/blog';
import { Head } from 'vite-react-ssg';
import { Container, Title, Text, Card, Stack, Group } from '@mantine/core';
import { useLocation } from 'react-router-dom';

const Blog: React.FC = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    return (
        <Layout onlyRequired={false}>
            <Head>
                <meta charSet="utf-8" />
                <title>{t('blog.title')}</title>
                <link rel="canonical" href={`https://calensync.live${location.pathname.replace('/en', '')}`} />
                <link rel="alternate" href={`https://calensync.live${PUBLIC_URL}/es/blog`} hrefLang="es" />
                <link rel="alternate" href={`https://calensync.live${PUBLIC_URL}/fr/blog`} hrefLang="fr" />
                <link rel="alternate" href={`https://calensync.live${PUBLIC_URL}/en/blog`} hrefLang="en" />
                <link rel="alternate" href={`https://calensync.live${PUBLIC_URL}/it/blog`} hrefLang="it" />
                <link rel="alternate" href={`https://calensync.live${PUBLIC_URL}`} hrefLang="x-default" />
                <meta name="description" content={t("blog.meta.description")} />
                <meta name="og:title" content={t("blog.meta.og_title")} />
                <meta name="og:url" content={`https://calensync.live${PUBLIC_URL}`} />
                <meta name="og:description" content={t("blog.meta.description")} />
            </Head>
            <Container size="md">
                <Group mt="md" mb="lg">
                    <Stack>
                        <Title order={1} fw={300}>Blog</Title>
                        <Text size="lg" c="dimmed">What we've talked about recently..</Text>
                    </Stack>
                </Group>
            </Container>

            <Container size="md" py="xl">
                {sortBlogsByDate(blogs as RouteWrapper<ExtraProperties>).map((data) => {
                    return [getBlogForLanguage(data, i18n.language, "en") as BlogProperties & ExtraProperties].map((blog) => (
                        <Card 
                            shadow="sm"
                            withBorder
                            key={blog.url} 
                            component="a" 
                            href={`${PUBLIC_URL}${blog.url}`}
                            mb="md"
                            padding="md"
                            className='blog-card'
                        >
                            <Title order={2}>{blog.title}</Title>
                            <Text c="dimmed" mt="xs">
                                {blog.headline}
                            </Text>
                        </Card>
                    ))
                })}
            </Container>
        </Layout>
    );
};

export default Blog;